module.exports = __webpack_public_path__ + "img/pica3.5deb4709.png";